import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, typography, fluidTypeScale } =
    useTheme();

  return {
    base: css`
      background-color: ${colors.white};
      box-shadow: 0px 4px 6px rgba(91, 104, 133, 0.1);
      border-radius: 8px;
      margin-bottom: ${spacing.s};
      position: relative;
      padding-top: 20px;
      margin-right: 10px;

      ${breakpoints.xl} {
        padding: ${spacing.m} ${spacing.l};
        padding-bottom: 0;
        margin-bottom: ${spacing.m};
      }
    `,
    tabs: css`
      display: grid;
      grid-template-columns: 1fr 1fr;
      border: 1px solid ${colors.blue};
    `,
    tab: isSelected => css`
      ${typography.headings[6].mobile};
      color: ${colors.blue};
      padding: 0.8125rem;
      letter-spacing: 0.01rem;
      font-size: 0.875rem;
      font-weight: 400;
      text-transform: uppercase;
      border-radius: 0;

      ${isSelected &&
      css`
        color: ${colors.white};
      `};

      ${breakpoints.xl} {
        padding: ${spacing.s};
      }
    `,
    cards: css`
    ${breakpoints.l} {
    :nth-of-type(2) {
    margin-top: 3.5rem;
    }
    `,
    innerWrapper: css`
      padding-bottom: 1.5rem;
    `,
    card: css`
      grid-auto-rows: 8.3rem;
    `,
    waysContainer: css`
      border: 1px solid ${colors.lightGrey};
      margin-bottom: -2px;
      border-radius: 8px;
      width: 291px;
      margin-right: 0;
      ${breakpoints.mm_xs_s}{
        margin-bottom: -18px;
      }
    `,
    header: css`
      text-transform: uppercase;
      font-size: ${fluidTypeScale.font12_12};
      color: ${colors.red};
      font-weight: 700;
      letter-spacing: 0.12em;
      cursor: pointer;
      line-height: 20px;

      ${breakpoints.l} {
        text-align: left;
        margin-bottom: 10px;
      }
    `,
    description: isExpanded => css`
    color: ${colors.navy};
    cursor: pointer;
    font-size: ${fluidTypeScale.font18_20};
    line-height: 24px;
    ${
      isExpanded === true &&
      css`
        height: auto;
      `
    }

    ${breakpoints.l} {
    font-size: ${fluidTypeScale.font18_20};
    font-weight: 400;
    line-height: 28px;
    text-align: left;     
    `,
    infoSection: css`
      ${breakpoints.l} {
        min-width: 15.625rem;
      }
    `,
    learnMore: css`
      display: flex;
      align-items: center;
      padding: 8px 0px 8px 0px;
      margin-top: 30px;
      border-top: 2px solid ${colors.lightGrey};
      margin-top: 25px;
      display: flex;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    `,
    imgSection: ({ desktop, mobile }, indexVal) => css`
      width: 100%;
      height: 195px;
      border-radius: 8px 8px 0px 0px;
      background: url(${mobile.src}) 0 0 no-repeat;
      background-size: cover;
      position: relative;
      cursor: pointer;
      margin-left: 1px !important;

      &::after {
      }

      ${breakpoints.l} {
        background: url(${desktop.src}) 0 0 no-repeat;
        background-size: cover;
      }

      .youtube {
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
      }
    `,

    cardalign: isExpanded => css`
      background-color: ${colors.white};
      padding: 32px 24px 15px 24px;
      ${isExpanded === true &&
      css`
        height: auto;
      `}
    `,
    learnmore: css`
      font-size: ${fluidTypeScale.font15_15};
      letter-spacing: 0.12em;
      text-align: left;
      color: ${colors.navy};
      text-transform: uppercase;
      font-weight: 700;
      line-height: 16px;
    `,
    link: css`
      color: ${colors.navy};
      text-decoration: none;
      touch-action: auto;
      &:active {
        text-decoration: underline;
        text-decoration-color: ${colors.navy};
      }
    `,
    learnmoreArrow: css`
      margin-left: auto;
    `,
    quickLinkContainer: css`
      display: inline-flex;
      height: 100%;
      background-color: ${colors.white};
      padding-top: 5px;
    `,
    showMore: css`
      color: ${colors.next_grey};
      cursor: pointer;
      font-weight: 700;
      text-decoration: none;
      display: inline-block;
      &:hover {
        text-decoration: underline;
      }
    `,
    expandArrow: css`
      display: inline-block;
      margin-left: 5px;
      vertical-align: middle;
    `,
  };
};
